



























































import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { Component, Prop } from "vue-property-decorator";
import Debug from "../utility/Debug.vue";
import LatestEntriesCardEmpty from "../cards/LatestEntriesCardEmpty.vue";
import Card from "../utility/Card.vue";
import { ThgThgMeterReadingViewModelGen } from "@/services/thg/v1/data-contracts";
import { IThg } from "@/models/thg.entity";

@Component({ components: { Debug, LatestEntriesCardEmpty, Card } })
export default class ThgBillingSelectionThgBaseData extends DarkModeHighlightMixin {
  @Prop()
  thgBaseData!: ThgThgMeterReadingViewModelGen | IThg;

  get width() {
    if (this.$vuetify.breakpoint.smAndDown) {
      return "100%";
    } else {
      return "250px";
    }
  }

  loading = true;

  locked = true;

  toggleLock = () => {
    this.locked = !this.locked;
  };
}
